import cx from 'classnames'
import { type AnchorHTMLAttributes } from 'react'

import SimpleLink from '@components/simple-link'
import {
  type ButtonProps,
  getButtonStyles,
  ButtonIcon,
  ButtonLabel,
} from './button'

export {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  ButtonIconAlignment,
} from './button'

type ButtonLinkProps = {
  href: string
} & ButtonProps &
  Pick<
    AnchorHTMLAttributes<HTMLAnchorElement>,
    | 'id'
    | 'rel'
    | 'target'
    | 'tabIndex'
    | 'onClick'
    | 'className'
    | 'style'
    | 'children'
  >

const ButtonLink = ({
  id,
  href,
  target,
  rel,
  tabIndex,
  variant,
  size,
  color,
  icon,
  iconAlignment,
  isActive,
  hideLabelUntil,
  onClick,
  className,
  style,
  children,
}: ButtonLinkProps) => (
  <SimpleLink
    id={id}
    href={href}
    target={target}
    tabIndex={tabIndex}
    rel={rel}
    className={cx(
      'group',
      getButtonStyles({
        variant,
        size,
        color,
        isActive,
        icon,
        hideLabelUntil,
        children,
      }),
      className
    )}
    style={style}
    onClick={onClick}
  >
    {children && (
      <ButtonLabel hideUntil={hideLabelUntil}>{children}</ButtonLabel>
    )}
    {icon && <ButtonIcon name={icon} alignment={iconAlignment} size={size} />}
  </SimpleLink>
)

export default ButtonLink
